import { render } from "./Freesub.vue?vue&type=template&id=1149639c&scoped=true"
import script from "./Freesub.vue?vue&type=script&lang=js"
export * from "./Freesub.vue?vue&type=script&lang=js"

import "./Freesub.vue?vue&type=style&index=0&id=1149639c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1149639c"]])

export default __exports__